import { defineComponent, reactive, watch } from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import VueI18n from 'vue-i18n'
const SelectContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    i18n: {
      type: VueI18n
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })

    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const deleteHtmlTag = (str) => {
      str = str.replace(/<[^>]+>|&[^>]+;/g, '').trim() //去掉所有的html标签和 之类的特殊符合
      return str
    }

    const selectChange = (value) => {
      state.editItem.value = value
      state.editItem.isShowInputError = false
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }
    return () => {
      return (
        <div class="select-topic-content">
          <el-select
            size="medium"
            placeholder={props.i18n?.t('common.selectPlaceholder')}
            value={state.editItem.value}
            onInput={(value) => selectChange(value)}>
            {props.item.topicSetting.topicOptionSetting?.map((sitem) => {
              return (
                <el-option
                  key={sitem.optionId}
                  label={deleteHtmlTag(sitem.optionName)}
                  value={sitem.optionId}>
                  <span
                    class="select-item-span"
                    domPropsInnerHTML={sitem.optionName}></span>
                </el-option>
              )
            })}
          </el-select>
        </div>
      )
    }
  }
})

export default SelectContent
